import { Request } from "./HttpService";
export const TechAreaService = {
  getAll(pageSize, pageNumber, description) {
    let url = `vitae/TechArea/${pageSize}/${pageNumber}`;
    if (description) url += `?description=${description}`;
    return Request(url, "GET").then((data) => {
      return data;
    });
  },
  getAllTechAreas() {
    return Request(`vitae/TechArea`, "GET").then((data) => {
      return data;
    });
  },
  getbyId(id) {
    return Request(`vitae/TechArea/${id}`, "GET").then((data) => {
      return data;
    });
  },
  createOrUpdate(techArea) {
    return Request(`vitae/TechArea`, "POST", techArea).then((data) => {
      return data;
    });
  },
  delete(id) {
    return Request(`vitae/TechArea/${id}`, "DELETE").then((data) => {
      return data;
    });
  }
};
